<template>
  <CustomTable title="" :rowsData="this.rowsData" :columns="this.priceColumns" :loading="isFetching" :custom-body="true"
    :small="true" :sticky-header="false" :add-btn="true" :on-add-click="this.onAddClick" :addBtnTitle="'Добавить цену'">
    <template #customBody="props">
      <q-tr>
        <custom-table-cell align="center" verticalAlign="center">
          {{ new Date(props.row.rowversion).toLocaleString('ru-RU') }}
        </custom-table-cell>

        <custom-table-cell align="left" verticalAlign="center">
          {{ props.row.employee_fio }}
        </custom-table-cell>

        <custom-table-cell align="center" verticalAlign="center">
          {{ props.row.date_begin }} - {{ props.row.date_end }}
        </custom-table-cell>

        <custom-table-cell align="right" verticalAlign="center">
          <Amount :value="props.row.old_price_whole" />
        </custom-table-cell>

        <custom-table-cell align="right" verticalAlign="center">
          <Amount :value="props.row.new_price_whole" />
        </custom-table-cell>

        <custom-table-cell align="center" verticalAlign="center">
          <div v-if="!!props.row.price_diff_whole" class="tw-flex tw-gap-2 tw-nowrap tw-items-center">
            <span :class="getDiffClass(props.row.price_diff_whole)">
              {{ formatDiffValue(props.row.price_diff_whole) }}
            </span>
            <span v-if="!!props.row.price_diff_percent" :class="['tw-text-xs', getDiffClass(props.row.price_diff_percent)]">
              ({{ formatDiffPercent(props.row.price_diff_percent) }})
            </span>
          </div>
        </custom-table-cell>

        <custom-table-cell align="center" verticalAlign="center">
          <SvgIcon name="edit" color="#1BB81B" style="width: 16px; height: 16px; cursor: pointer"
            @click="onEditClick(props.row)" />
        </custom-table-cell>

        <custom-table-cell align="center" vertical-align="center">
          <CustomIcon icon="trash" approveMode :approve="() => this.delete(props.row?.material_provider_price_id)" />
        </custom-table-cell>
      </q-tr>
    </template>
  </CustomTable>
</template>

<script>
import { useCustomSnackbar } from '@/_helpers/hooks/useCustomSnackbar'
import Clickable from '@/components/common/Clickable'
import CustomIcon from '@/components/common/CustomIcon'
import CustomPopup from '@/components/common/CustomPopup'
import CustomTable from '@/components/common/CustomTable'
import CustomTableCell from '@/components/common/CustomTable/custom-table-cell'
import SvgIcon from '@/components/common/SvgIcon'
import CustomCheckbox from '@/components/form/CustomCheckbox'
import { MODAL_NAMES } from '@/constants'
import { useAppStore } from '@/services/store/app'
import PriceTable from './PriceTable.vue'
import { deleteProviderPrice, priceColumns, updProviderPrice, getMaterialProviderPriceList } from './services'
import {numberWithCommas} from "@/services"
import Amount from '@/components/common/Amount.vue';

export default {
  name: 'LinksTable',
  components: {
    CustomIcon,
    CustomTableCell,
    CustomTable,
    CustomPopup,
    SvgIcon,
    CustomCheckbox,
    Clickable,
    PriceTable,
    Amount,
  },
  props: ['provider', 'filters', 'onDataChange'],
  data() {
    return {
      priceColumns,
      rowsData: [],
      isFetching: false,
      params: {
        material_id: this.provider.material_id,
        provider_id: this.provider.provider_id,
      }
    }
  },
  methods: {
    numberWithCommas,
    getDiffClass(value) {
      const numericValue = Number(value)
      if (!Number.isFinite(numericValue)) return ''
      if (numericValue > 0) return 'diff-value diff-value--positive'
      if (numericValue < 0) return 'diff-value diff-value--negative'
      return 'diff-value'
    },
    formatDiffValue(value) {
      const numericValue = Number(value)
      if (!Number.isFinite(numericValue)) return '-'
      const sign = numericValue > 0 ? '+' : ''
      return `${sign}${numericValue.toLocaleString('ru-RU', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`
    },
    formatDiffPercent(value) {
      const formattedValue = this.formatDiffValue(value)
      if (formattedValue === '-') return formattedValue
      return `${formattedValue}%`
    },
    onAddClick() {
      this.showModal(MODAL_NAMES.AddMaterialProviderPrice, {
        title: 'Добавить цену',
        onSubmit: this.handlePriceAdd,
        body: { material_provider_id: this.provider.material_provider_id },
      })
    },
    onEditClick(row) {
      this.showModal(MODAL_NAMES.AddMaterialProviderPrice, {
        title: 'Редактировать цену',
        onSubmit: body => this.handlePriceEdit(body),
        body: row,
      })
    },
    async handlePriceAdd(body) {
      this.isFetching = true;
      const res = await updProviderPrice(body, this.params);
      if (!res) {
        return;
      }
      this.rowsData = res || [];
      this.isFetching = false;
      this.refreshProvidersData();
      this.refreshMaterialsData();
      this.showSucceedSnackbar();
      this.closeModal();
    },
    async handlePriceEdit(body) {
      this.isFetching = true;
      const res = await updProviderPrice(body, this.params);
      if (!res) {
        return;
      }
      this.rowsData = res || [];
      this.isFetching = false;
      this.refreshProvidersData();
      this.refreshMaterialsData();
      this.showSucceedSnackbar();
      this.closeModal();
    },
    async getData() {
      this.isFetching = true
      const res = await getMaterialProviderPriceList(this.params)
      this.isFetching = false
      if (!res) return
      this.rowsData = res || []
    },
    async delete(id) {
      this.isFetching = true
      const res = await deleteProviderPrice(id, this.params)
      this.isFetching = false
      if (!res) return
      this.rowsData = res || []
      this.refreshProvidersData();
      this.refreshMaterialsData();
      this.showSucceedSnackbar()
    },
    refreshProvidersData() {
      this.$emit('refresh-providers-data');
    },
    refreshMaterialsData() {
      this.$emit('refresh-materials-data');
    },
  },
  mounted() {
    this.getData()
  },
  setup() {
    const { showSucceedSnackbar, showErrorSnackbar } = useCustomSnackbar()
    const { showModal, closeModal } = useAppStore()
    return { showSucceedSnackbar, showErrorSnackbar, showModal, closeModal }
  },
}
</script>

<style scoped lang="scss">
.link {
  color: #00368b;
  cursor: pointer;
  font-weight: 500;

  &:hover {
    text-decoration: underline;
  }
}

.diff-value {
  font-weight: 600;
}

.diff-value--positive {
  color: #16A34A;
}

.diff-value--negative {
  color: #DC2626;
}

</style>
